import en from './en.json';
import { createI18n } from 'vue-i18n';

// You can use `defineI18nConfig` to get type inferences for options to pass to vue-i18n.
export default createI18n({
    legacy: false,
    locale: 'en-US',
    messages: {
      en,
    },
    fallbackLocale: 'en',
    silentTranslationWarn: false,
    fallbackWarn: false,
    missingWarn: false,
    preload: true,
});
